import React from "react";
import styles from "../Assets/css/mobilemaster.module.css";
const MobileMasterClass = () => {
	return (
		<div class="container-fluid styles.mainmobJ justify-content-center">
			<div class="row justify-content-center ">
				<div
					class={
						"col-sm-7 " +
						styles.purpleformMJ +
						" py-3 pb-5 px-5 " +
						styles.form1MJ
					}
				>
					<p>How to crack jobs in top product companies</p>
					<div class={styles.mobilehrwhiteJ}>
						<p class="mb-0">21st June, 2021 5:00PM - 6:00PM</p>
					</div>
				</div>

				<div class={"col-12 my-3 " + styles.secondpartformMJ}>
					<div class={styles.formMhd2J + " mt-5"}>
						<h2>Personal information</h2>
					</div>
					<div class={styles.formcenterMJ + " mt-5"}>
						<form class={styles.whiteformMJ}>
							<div>
								<span class={styles.boldformTextMJ}>
									First Name
								</span>
								<br />
								<input
									class={styles.formcontrol1}
									type="text"
									name="name"
									placeholder="John"
								/>
							</div>
							<br />
							<div class="mt-1">
								<span class={styles.boldformTextMJ}>Email</span>
								<br />
								<input
									class={styles.formcontrol1}
									type="email"
									name="email"
									placeholder="xyz@gmail.com"
								/>
							</div>
							<br />
							<div class="mt-1">
								<span class={styles.boldformTextMJ}>
									Phone Number
								</span>
								<br />
								<input
									class={styles.formcontrol1}
									type="number"
									name="Phone"
									placeholder="Do not put country code"
								/>
							</div>
							<br />
							<div class="mt-1">
								<span class={styles.boldformTextMJ}>
									Current City
								</span>
								<br />
								<input
									class={styles.formcontrol1}
									type="text"
									name="city"
									placeholder="Enter your city name"
								/>
							</div>
						</form>
					</div>

					<div class={styles.formMhd2J + " mt-5"}>
						<h2>College Details</h2>
					</div>

					<div class="mt-5">
						<span class={styles.boldformTextMJ}>
							Graduation Degree
						</span>
						<br />

						<div class="mt-2" data-role="fieldcontain">
							<fieldset
								data-role="controlgroup"
								data-type="horizontal"
							>
								<input
									type="radio"
									name="radio-choice-1"
									id="radio-choice-1"
									value="choice-1"
								/>
								<label
									for="radio-choice-1"
									class={styles.radiotextJ}
								>
									Bachelor of Engg./tech
								</label>
								<input
									type="radio"
									class=""
									name="radio-choice-1"
									id="radio-choice-2"
									value="choice-2"
								/>
								<label
									for="radio-choice-2"
									class={styles.radiotextJ}
								>
									{" "}
									Bachelor of Commerce
								</label>
								<input
									type="radio"
									class=""
									name="radio-choice-1"
									id="radio-choice-3"
									value="choice-3"
								/>
								<label
									for="radio-choice-3"
									class={styles.radiotextJ}
								>
									{" "}
									Bachelor of Science
								</label>
								<input
									type="radio"
									class=""
									name="radio-choice-1"
									id="radio-choice-4"
									value="choice-4"
								/>
								<label
									for="radio-choice-4"
									class={styles.radiotextJ}
								>
									{" "}
									PGDM/MBA
								</label>
								<input
									type="radio"
									class=""
									name="radio-choice-1"
									id="radio-choice-5"
									value="choice-5"
								/>
								<label
									for="radio-choice-5"
									class={styles.radiotextJ}
								>
									{" "}
									BBA
								</label>
								<input
									type="radio"
									class=""
									name="radio-choice-1"
									id="radio-choice-6"
									value="choice-6"
								/>
								<label
									for="radio-choice-6"
									class={styles.radiotextJ}
								>
									{" "}
									Others
								</label>
							</fieldset>
						</div>
						<br />

						<div class="mt-1">
							<span class={styles.boldformTextMJ}>
								Department
							</span>
							<br />

							<div class="mt-2">
								<input
									type="radio"
									name="radio-1"
									id="radio-1"
									value="choice-1"
								/>
								<label class={styles.radiotextJ} for="radio-1">
									CSE
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-1"
									id="radio-2"
									value="choice-2"
								/>
								<label class={styles.radiotextJ} for="radio-2">
									ECE
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-1"
									id="radio-3"
									value="choice-3"
								/>
								<label class={styles.radiotextJ} for="radio-3">
									EEE
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-1"
									id="radio-4"
									value="choice-4"
								/>
								<label class={styles.radiotextJ} for="radio-4">
									IT
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-1"
									id="radio-5"
									value="choice-5"
								/>
								<label class={styles.radiotextJ} for="radio-5">
									MECHANICAL
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-1"
									id="radio-6"
									value="choice-6"
								/>
								<label class={styles.radiotextJ} for="radio-6">
									CIVIL
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-1"
									id="radio-7"
									value="choice-7"
								/>
								<label class={styles.radiotextJ} for="radio-7">
									OTHERS
								</label>
							</div>
						</div>
						<br />

						<div class="mt-1">
							<span class={styles.boldformTextMJ}>
								Year of Study{" "}
							</span>
							<br />

							<div class="mt-2">
								<input
									type="radio"
									name="radio-op-1"
									id="radio-op-1"
									value="choice-1"
								/>
								<label
									class={styles.radiotextJ}
									for="radio-op-1"
								>
									1
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-op-1"
									id="radio-op-2"
									value="choice-2"
								/>
								<label
									class={styles.radiotextJ}
									for="radio-op-2"
								>
									2
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-op-1"
									id="radio-op-3"
									value="choice-3"
								/>
								<label
									class={styles.radiotextJ}
									for="radio-op-3"
								>
									3
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-op-1"
									id="radio-op-4"
									value="choice-4"
								/>
								<label
									class={styles.radiotextJ}
									for="radio-op-4"
								>
									4
								</label>
								<input
									type="radio"
									class="ml-2"
									name="radio-op-1"
									id="radio-op-5"
									value="choice-5"
								/>
								<label
									class={styles.radiotextJ}
									for="radio-op-5"
								>
									5
								</label>
							</div>
						</div>
						<br />
					</div>

					<div class={styles.formMhd2J + " mt-5"}>
						<h2>Others</h2>
					</div>

					<form class={styles.whiteformMJ}>
						<div class="mt-5">
							<span class={styles.boldformTextMJ}>
								Area Of Interest
							</span>
							<br />
							<div class="row d-flex mt-2">
								<div class=" ml-3">
									<input
										type="radio"
										name="radio-1"
										id="radio-1"
										value="choice-1"
									/>
									<label
										class={styles.radiotextJ}
										for="radio-1"
									>
										Product Development
									</label>
								</div>
								<div class=" ml-3 ">
									<input
										type="radio"
										name="radio-1"
										id="radio-2"
										value="choice-1"
									/>
									<label
										class={styles.radiotextJ}
										for="radio-2"
									>
										Software developmet
									</label>
								</div>
								<div class=" ml-3 ">
									<input
										type="radio"
										name="radio-1"
										id="radio-3"
										value="choice-1"
									/>
									<label
										class={styles.radiotextJ}
										for="radio-3"
									>
										Datascience
									</label>
								</div>
								<div class=" ml-3 ">
									<input
										type="radio"
										name="radio-1"
										id="radio-4"
										value="choice-1"
									/>
									<label
										class={styles.radiotextJ}
										for="radio-4"
									>
										Machine Learning and Artificial
										Intelligence{" "}
									</label>
								</div>
								<div class=" ml-3 ">
									<input
										type="radio"
										name="radio-1"
										id="radio-5"
										value="choice-1"
									/>
									<label
										class={styles.radiotextJ}
										for="radio-5"
									>
										Cyber Security{" "}
									</label>
								</div>
								<div class=" ml-3 ">
									<input
										type="radio"
										name="radio-1"
										id="radio-6"
										value="choice-1"
									/>
									<label
										class={styles.radiotextJ}
										for="radio-6"
									>
										Full Stack Development
									</label>
								</div>
								<div class=" ml-3 ">
									<input
										type="radio"
										name="radio-1"
										id="radio-7"
										value="choice-1"
									/>
									<label
										class={styles.radiotextJ}
										for="radio-7"
									>
										Others{" "}
									</label>
								</div>
							</div>

							<br />
							<div>
								<span class={styles.boldformTextMJ}>
									Enter Employee Refer code if any
								</span>
								<br />
								<input
									class="formcontrol1"
									type="text"
									name="city"
									placeholder="Type code here"
								/>
							</div>
							<br />
							<div>
								<span class={styles.boldformTextMJ}>
									{" "}
									Do you have any Question to the speaker ?
								</span>
								<br />
								<input
									class="formcontrol1"
									type="text"
									name="city"
									placeholder=" Enter Your Question"
								/>
							</div>

							<div class="my-5"></div>

							<div class={styles.leftformtextMJ + " my-5"}>
								<p>By Clicking submit you agree to our</p>
								<span class={styles.purpleboldMJ}>
									Terms & Conditions
								</span>

								<div class="d-flex">
									<button
										class={
											"btn " +
											styles.buttonformMJ +
											" p-2 mx-2"
										}
									>
										BACK
									</button>
									<button
										class={
											"btn " +
											styles.buttonformMJ +
											" p-2"
										}
									>
										SUBMIT
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default MobileMasterClass;
